import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalFooter() {
  return (
    <footer
      className="mt-auto border-t bg-slate-50 text-slate-600"
      data-testid="legal-footer"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 grid gap-4 md:grid-cols-2 md:items-center">
        <div>
          <p className="text-sm font-semibold text-slate-800">JugnuLive AI</p>
          <p className="text-xs text-slate-500 mt-1">
            © {new Date().getFullYear()} JugnuLive AI. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Contact: <a href="tel:9538681000" className="text-primary hover:underline" data-testid="footer-phone">9538681000</a>
            {' · '}
            <a href="mailto:admin@jugnu.live" className="text-primary hover:underline" data-testid="footer-email">admin@jugnu.live</a>
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-4 gap-y-2 md:justify-end text-xs">
          <Link to="/blog" className="hover:text-primary hover:underline font-semibold text-primary" data-testid="footer-link-blog">
            Jugnu Junction
          </Link>
          <Link to="/legal/privacy" className="hover:text-primary hover:underline" data-testid="footer-link-privacy">
            Privacy Policy
          </Link>
          <Link to="/legal/terms" className="hover:text-primary hover:underline" data-testid="footer-link-terms">
            Terms &amp; Conditions
          </Link>
          <Link to="/legal/refund" className="hover:text-primary hover:underline" data-testid="footer-link-refund">
            Refund &amp; Cancellation
          </Link>
          <Link to="/legal/shipping" className="hover:text-primary hover:underline" data-testid="footer-link-shipping">
            Shipping &amp; Delivery
          </Link>
          <Link to="/legal/contact" className="hover:text-primary hover:underline" data-testid="footer-link-contact">
            Contact Us
          </Link>
        </nav>
      </div>
    </footer>
  );
}
